var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOkSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00065 47C5.00065 70.1606 23.84 89 47.0006 89C70.1613 89 89.0006 70.1606 89.0006 47C89.0006 23.8393 70.1613 4.99998 47.0006 4.99998C23.84 4.99998 5.00065 23.8393 5.00065 47ZM0.333984 47C0.333984 21.268 21.2687 0.333313 47.0007 0.333313C72.7327 0.333313 93.6673 21.268 93.6673 47C93.6673 72.732 72.7327 93.6667 47.0007 93.6667C21.2687 93.6667 0.333984 72.732 0.333984 47ZM65.6737 24.7399C66.369 23.6479 67.811 23.3492 68.8984 24.0306C69.981 24.7259 70.303 26.1679 69.6077 27.2552L45.5604 64.9199C45.173 65.5219 44.5337 65.9139 43.8244 65.9792C43.745 65.9886 43.6704 65.9932 43.591 65.9932C42.961 65.9932 42.3544 65.7412 41.911 65.2792L24.3177 47.0046C23.4264 46.0759 23.4544 44.5966 24.383 43.7052C25.307 42.8186 26.7864 42.8419 27.6824 43.7659L43.2177 59.9079L65.6737 24.7399Z",
    fill: "#3A8340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOkSuccess);
export default __webpack_public_path__ + "static/media/ic_ok_success.7baafe60851c066c1772c45cdde56abc.svg";
export { ForwardRef as ReactComponent };